import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import webTokenStorer from "../../utils/webStorer"
import { Navigate, Outlet } from "react-router-dom";
import { SOCIETY_PORTAL, SOCIETY_PORTAL_LOGIN } from "../../Routing/routes";
import { relogin } from "../../redux/actions/AuthActions/LoginAction";

const SocietyPortal = () => {
    const dispatch = useDispatch();
    const getToken = webTokenStorer.getToken();
    const hydratedRef = useRef(false);

    // Hydrate active society + permissions once when entering the authenticated
    // portal. This covers every entry path (hard reload of a deep page, and the
    // redirect from the login page at "/"), so permission-gated routes always have
    // permissions to check against instead of getting stuck loading or flashing 403.
    useEffect(() => {
        if (getToken && !hydratedRef.current) {
            hydratedRef.current = true;
            dispatch(relogin({}));
        }
    }, [getToken, dispatch]);

    return (
        <>
            {!getToken && <Navigate to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN} />}
            <Outlet />
        </>
    )
}

export default SocietyPortal;
